import Module from './categoriesList'
export default Module
